import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './GroupCard.scss';
const GroupCard = ({ username , imageUrl , className , biData  })=>/*#__PURE__*/ React.createElement(BiLink, {
        href: Url.userLink(username),
        className: classnames(s['root'], className),
        biData: biData
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['img-wrap']
    }, imageUrl && /*#__PURE__*/ React.createElement("img", {
        src: imageUrl,
        alt: "",
        loading: "lazy"
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, username));
GroupCard.displayName = 'GroupCard';
export default GroupCard;
